import { Card, CardContent } from "../components/ui/card";
import { MapPin, Clock } from "lucide-react";
import manipalImage from "../assets/images/mahe.jpg";
import kmcImage from "../assets/images/kmc.jpg";
import krishnaMuttImage from "../assets/images/krishnamutt.jpg";
import malpeImage from "../assets/images/malpe.jpg";
import hasthashilpaImage from "../assets/images/hasta-shilpa.jpg";
import planetariumImage from "../assets/images/planetarium.jpeg";

export default function NearbyPlacesPage() {
  const places = [
    {
      name: "Manipal Academic Area",
      distance: "5 minutes",
      description: "Home to prestigious educational institutions including Manipal Institute of Technology and Kasturba Medical College",
      image: manipalImage
    },
    {
      name: "KMC Hospital Manipal",
      distance: "5 minutes",
      description: "One of the finest multi-specialty hospitals in the region, providing world-class healthcare services",
      image: kmcImage
    },
    {
      name: "Udupi Sri Krishna Temple",
      distance: "15 minutes",
      description: "Famous ancient Hindu temple dedicated to Lord Krishna, known for its unique idol and religious significance",
      image: krishnaMuttImage
    },
    {
      name: "Malpe Beach",
      distance: "20 minutes",
      description: "Beautiful pristine beach perfect for relaxation, water sports, and enjoying stunning sunsets",
      image: malpeImage
    }, {
      name: "Hasta Shilpa Heritage Village",
      distance: "10 minutes",
      description: "Open-air museum featuring traditional homes, antiques, and Karnataka’s cultural heritage.",
      image: hasthashilpaImage
    }, {
      name: "Dr. TMA Pai Planetarium",
      distance: "5 minutes",
      description: "Modern digital planetarium offering immersive astronomy shows and space science experiences, popular among students and families.",
      image: planetariumImage
    }
  ];

  return (
    <div className="min-h-screen py-16 bg-gradient-to-b from-white to-[#FFF8DC]">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#8B6F47] mb-4">
            Nearby Places
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Strategically located with easy access to educational institutions, healthcare facilities, and tourist attractions
          </p>
        </div>

        {/* Places Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {places.map((place, index) => (
            <Card
              key={index}
              className="overflow-hidden border-2 border-[#E6D5C3] hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={place.image}
                  alt={place.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

                {/* Distance Badge */}
                <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full flex items-center space-x-2 shadow-lg">
                  <Clock className="w-4 h-4 text-[#8B6F47]" />
                  <span className="font-semibold text-[#8B6F47] text-sm">
                    {place.distance}
                  </span>
                </div>
              </div>

              {/* Content */}
              <CardContent className="p-6">
                <div className="flex items-start space-x-3 mb-3">
                  <MapPin className="w-5 h-5 text-[#8B6F47] flex-shrink-0 mt-1" />
                  <h3 className="text-2xl font-serif font-bold text-[#8B6F47]">
                    {place.name}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {place.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 max-w-4xl mx-auto">
          <Card className="bg-white border-2 border-[#E6D5C3] shadow-md">
            <CardContent className="p-8">
              <h3 className="text-2xl font-serif font-bold text-[#8B6F47] mb-6 text-center">
                Perfect Location for Everyone
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#FFF8DC] rounded-full flex items-center justify-center mx-auto mb-3">
                    <MapPin className="w-8 h-8 text-[#8B6F47]" />
                  </div>
                  <h4 className="font-semibold text-[#8B6F47] mb-2">For Students</h4>
                  <p className="text-sm text-gray-600">
                    Walking distance to colleges and university campus
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#FFF8DC] rounded-full flex items-center justify-center mx-auto mb-3">
                    <MapPin className="w-8 h-8 text-[#8B6F47]" />
                  </div>
                  <h4 className="font-semibold text-[#8B6F47] mb-2">For Hospital Visitors</h4>
                  <p className="text-sm text-gray-600">
                    Minutes away from KMC Hospital for patient attendants
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#FFF8DC] rounded-full flex items-center justify-center mx-auto mb-3">
                    <MapPin className="w-8 h-8 text-[#8B6F47]" />
                  </div>
                  <h4 className="font-semibold text-[#8B6F47] mb-2">For Tourists</h4>
                  <p className="text-sm text-gray-600">
                    Quick access to temples, beaches, and local attractions
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
